import React from 'react';
import {
  CardV2,
  BreakPointItem,
  BREAKPOINTS,
} from '@tfecom-thermofisher/react-komodo-design';

import { Summary } from 'src/components/OligoDNA/components';

import './SummaryCard.style.scss';

const SummaryCard = () => (
  <BreakPointItem min={BREAKPOINTS.md}>
    <CardV2 classes={{ card: 'dna-summary-card' }}>
      <Summary showOrderSummaryTitle />
    </CardV2>
  </BreakPointItem>
);

export default SummaryCard;
